import { features } from '@/mocks/chigua';

export default function FeatureReads() {
  return (
    <section id="zhuanti" className="mx-auto w-full max-w-7xl scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="flex items-center gap-1.5 text-xs font-semibold tracking-widest text-primary-600">
            <i className="ri-file-edit-line"></i> 专题深读
          </p>
          <h2 className="heading-font mt-1.5 text-2xl font-extrabold text-foreground-950 md:text-3xl">
            不只是热闹，把门道也讲明白
          </h2>
        </div>
        <p className="hidden max-w-xs text-right text-xs leading-relaxed text-foreground-500 md:block">
          编辑部复盘与观察组的原创长文，帮你把热度背后的逻辑理顺。
        </p>
      </div>

      <div className="mt-7 space-y-5">
        {features.map((f) => (
          <article
            key={f.id}
            className="group grid grid-cols-1 items-center gap-0 overflow-hidden rounded-lg border border-secondary-100 bg-background-50 lg:grid-cols-5"
          >
            <a href="#ts" className="block lg:col-span-2" aria-label={`阅读专题 ${f.title}`}>
              <div className="relative aspect-[3/2] overflow-hidden lg:aspect-auto lg:h-full">
                <img
                  src={f.img}
                  alt={f.title}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </a>
            <div className="flex flex-col p-5 lg:col-span-3 lg:p-7">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded bg-accent-100 px-2 py-1 text-[11px] font-semibold text-accent-800">
                  <i className="ri-quill-pen-line"></i> {f.kicker}
                </span>
                <span className="text-[11px] text-foreground-400">
                  {f.mins} · {f.views} 阅读
                </span>
              </div>
              <h3 className="heading-font mt-3 text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                <a href="#ts" className="transition-colors hover:text-primary-600">
                  {f.title}
                </a>
              </h3>
              <p className="mt-2.5 line-clamp-3 text-xs leading-relaxed text-foreground-600 md:text-sm">
                {f.excerpt}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-secondary-100 pt-4">
                <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-foreground-600">
                    <i className="ri-pencil-ruler-2-line text-[11px]"></i>
                  </span>
                  {f.author}
                </span>
                <a
                  href="#ts"
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  开始深读 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}